<template>
  <div class="site-header row">
    <div class="logo col-1 my-auto">
      <h1 class="mx-3"> LSR </h1>
    </div>
    <div id="nav" class="col-11 my-auto">
      <router-link to="/" class="px-4">Home</router-link>
      <router-link to="/review" class="px-4">Index</router-link>
      <router-link to="/about" class="px-4">About</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {},
  data () { return {} },
  components: {}
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.site-header {
  height: 10vh;
  background-color: $dark-green;
}

#nav{
  color: white;

  a {
    text-decoration: none;
    color: inherit;
    font-weight: bold;
  }
}

.logo {
  color: white;
}


</style>
